import React, { useMemo } from 'react'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { getCheapestSelectedPackageOptionWithDefault } from 'selectors/offerPage/offerPageSelectors'
import { getMultiRoomPackageTotals, MultiRoomPackageTotals } from 'selectors/offerPage/multipleRoomBookingSelectors'
import _BaseHotelFlightsToggleButton from './_BaseHotelFlightsToggleButton'
import { isMultipleRoomBookingActive } from 'selectors/offerPage/offerPageSharedSelectors'
import { EmptyObject } from 'lib/object/objectUtils'
import { preventRenderWithOpenFilter } from 'lib/offer/offerPageUtil'

interface Props {
  rooms?: Array<App.Occupants>
  cheapestSelectedOption: App.OfferPackageOptionView
  multiRoomPackageTotals: MultiRoomPackageTotals
}

function HotelFlightsToggleButton(props: Props) {
  const { rooms, cheapestSelectedOption, multiRoomPackageTotals } = props

  const {
    flightsAvailable,
    pricing: hotelPrice,
    memberPricing: hotelMemberPrice,
    pricingWithFlights,
    memberPricingWithFlights,
  } = useMemo(() => cheapestSelectedOption, [cheapestSelectedOption])

  const {
    hotelPrice: multipleRoomHotelPrice,
    hotelMemberPrice: multipleRoomHotelMemberPrice,
    hotelPlusFlightsPrice: multipleRoomFlightPrice,
    hotelPlusFlightsMemberPrice: multipleRoomMemberFlightPrice,
  } = multiRoomPackageTotals

  const hotelTotalPrice = useMemo(() => {
    if (hotelMemberPrice?.price) return (rooms?.length ?? 0) > 1 ? multipleRoomHotelMemberPrice : hotelMemberPrice.price
    return (rooms?.length ?? 0) > 1 ? multipleRoomHotelPrice : hotelPrice.price
  }, [hotelMemberPrice, rooms, multipleRoomHotelPrice, multipleRoomHotelMemberPrice, hotelPrice])

  const hotelFlightTotalPrice = useMemo(() => {
    if (memberPricingWithFlights?.price) return (rooms?.length ?? 0) > 1 ? multipleRoomMemberFlightPrice : memberPricingWithFlights.price
    return (rooms?.length ?? 0) > 1 ? multipleRoomFlightPrice : pricingWithFlights?.price ?? 0
  }, [memberPricingWithFlights, rooms?.length, multipleRoomMemberFlightPrice, multipleRoomFlightPrice, pricingWithFlights])

  return <_BaseHotelFlightsToggleButton
    flightsAvailable={flightsAvailable}
    isMemberPrice={!!hotelMemberPrice}
    hotelTotalPrice={hotelTotalPrice}
    hotelFlightTotalPrice={hotelFlightTotalPrice}
  />
}

export default withOfferPageAndReduxState((state, appState) => {
  const isMultiRoom = isMultipleRoomBookingActive(state, appState)
  return {
    rooms: state.rooms,
    cheapestSelectedOption: getCheapestSelectedPackageOptionWithDefault(appState, state),
    multiRoomPackageTotals: isMultiRoom ? getMultiRoomPackageTotals(state, appState) : EmptyObject,
    open: !!state.activeFilter,
  }
}, HotelFlightsToggleButton, preventRenderWithOpenFilter)
